module.exports = __webpack_public_path__ + "static/media/AmeliTeje3.823b77c4.jpeg";